import React from 'react'

import { Form, Col } from '_zari/core'

const FechaHastaFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA HASTA' htmlFor='input-fechaHasta' md={4} />
      <Col md={8}>
        <Form.InputDate 
        name="inputFecha"
        value={value} onChange={onChange} id='input-fechaHasta' />
      </Col>
    </Form.Group>
  )
}

export default FechaHastaFormGroup
